import CloudMark from './CloudMark';
import Wordmark from './Wordmark';

// Lockup OpenBackup = isotipo + wordmark. Nada mas.
//
// El tagline NO vive aca. A la proporcion del logo original (0.318 del
// wordmark) queda en 8.9px cuando size=28, ilegible; y agrandar el lockup
// hasta que el tagline llegue a 11px lo lleva a 381px de ancho, que no entra
// en la tarjeta de login. Al sacarlo, este componente queda siendo
// exactamente el logo de marca. El tagline se maqueta aparte en Login.js
// con la clase .ob-tagline.
//
// Proporciones medidas sobre el logo original, en funcion de `size`
// (el font-size del wordmark):
//
//   alto del isotipo ................ 2.248 * size
//   ancho del isotipo ............... 3.078 * size
//   separacion isotipo -> wordmark .. 0.925 * size
//   ancho del wordmark .............. ~6.90 * size
//   ancho total del lockup .......... ~10.9 * size
//
// Tamanos de uso:
//   sidebar desktop (util 188px) ... size 17  -> ~185 x 38 px
//   sidebar mobile  (barra 48px) ... size 13  -> ~142 x 29 px
//   login           (util 304px) ... size 26  -> ~283 x 58 px
//   setup           (util 520px) ... size 22  -> ~240 x 49 px
//   reset password  (util 296px) ... size 18  -> ~196 x 40 px

export default function Logo({ size = 28, tld = true, style, ...rest }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: size * 0.925,
        ...style,
      }}
      {...rest}
    >
      <CloudMark size={size * 2.248} />
      <Wordmark size={size} tld={tld} />
    </span>
  );
}
